import { inject, observer } from 'mobx-react'
import React from 'react'

@observer
class PhotoLayer extends React.Component {

  getEffects(){
    const { filters, type, photoType } = this.props
    if(photoType && (photoType === 'sticker' || photoType === 'gif')){
      return {}
    }
    const { 
      opacity,
      blur,
      saturation,
      brightness,
      contrast
    } = filters
    const effectsStyle = {
      filter: `blur(${blur / 10}px) opacity(${opacity / 100}) contrast(${contrast / 100}) brightness(${brightness / 100}) saturate(${saturation / 100})`
    }
    return effectsStyle
  }

  render(){
    const { dataSource, xPos, yPos } = this.props
    const effects = this.getEffects()
    return (
      <div className='photo-layer'>
        <img
          draggable={false}
          src={dataSource}
          className='photo-layer__photo'
          style={{
            height: '100%',
            width: '100%',
            ...effects
          }}
        />
      </div>
    )
  }

}

export default PhotoLayer